import { useState } from "react";
import { useViewScope } from "../auth/view-scope.js";

// UM.7 — VideoFrameStrip nayttaa kaikki 5 video-kehysta rinnakkain detail-
// modaalissa. Frame 0 = video-poster (5 % kohdalta), frame 1..4 =
// video-frame-N (25/50/75/90 %). Klikkaus avaa kehyksen lightbox:iin.

const FRAMES = [
  { idx: 0, label: "5 %" },
  { idx: 1, label: "25 %" },
  { idx: 2, label: "50 %" },
  { idx: 3, label: "75 %" },
  { idx: 4, label: "90 %" },
] as const;

export type VideoFrameStripProps = {
  assetId: string;
};

export function VideoFrameStrip({ assetId }: VideoFrameStripProps) {
  const { headerValue } = useViewScope();
  const [lightboxFrame, setLightboxFrame] = useState<number | null>(null);

  const scopeParam =
    headerValue === "self" ? "" : `&viewScope=${encodeURIComponent(headerValue)}`;

  return (
    <>
      <div className="grid grid-cols-5 gap-2">
        {FRAMES.map(({ idx, label }) => (
          <button
            key={idx}
            type="button"
            onClick={() => setLightboxFrame(idx)}
            className="group block rounded-md border border-slate-800 bg-slate-900/40 p-1 text-left transition hover:border-slate-600"
            title={`Avaa kehys ${idx + 1}/5 (${label})`}
          >
            <span className="block aspect-video overflow-hidden rounded bg-slate-800">
              <img
                src={`/assets/${assetId}/thumbnail?size=256&frame=${idx}${scopeParam}`}
                alt={`Kehys ${idx + 1}/5`}
                loading="lazy"
                className="h-full w-full object-cover transition group-hover:opacity-90"
              />
            </span>
            <span className="mt-1 block text-center text-[10px] text-slate-500">{label}</span>
          </button>
        ))}
      </div>

      {lightboxFrame !== null && (
        <div
          role="dialog"
          aria-modal="true"
          onClick={() => setLightboxFrame(null)}
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 p-8 backdrop-blur"
        >
          <img
            src={`/assets/${assetId}/thumbnail?size=1024&frame=${lightboxFrame}${scopeParam}`}
            alt={`Kehys ${lightboxFrame + 1}/5`}
            className="max-h-full max-w-full rounded shadow-2xl"
            onClick={(e) => e.stopPropagation()}
          />
          <button
            type="button"
            onClick={() => setLightboxFrame(null)}
            className="absolute right-6 top-6 rounded-md bg-slate-900/80 px-3 py-1 text-sm text-slate-200 hover:bg-slate-800"
          >
            Sulje (ESC)
          </button>
        </div>
      )}
    </>
  );
}
